import React from 'react'
import { Line,Pie,Bar } from 'react-chartjs-2';
import styles from './main.module.css'
import { WorldMap } from "react-svg-worldmap"


const mapData= 
[
  { country: "cn", value: 1000 }, // china
  { country: "in", value: 8000 }, // india
  { country: "us", value: 3000 },  // united states
  { country: "id", value: 400 },  // indonesia
  { country: "pk", value: 4000 },  // pakistan
  { country: "br", value: 100 },  // brazil
  { country: "ng", value: 200 },  // nigeria
  { country: "bd", value: 3000 },  // bangladesh
  { country: "ru", value: 500 },  // russia
  { country: "mx", value: 10 }   // mexico
]

const bardata = {
    labels: ['15-20', '20-25', '25-30', '35-40', '40-45', '50-55'],
    datasets: [
      {
        label: 'Age Group',
        data: [122, 205, 150, 50, 40, 45],
        backgroundColor: 'rgb(133, 36, 189)',

        borderColor:'rgb(133, 36, 189)',
        borderWidth: 1,
      },
    ],
  }



const pidata = {
    labels: ['Female', 'Male'],
    datasets: [
      {
        data: [20, 50],
        backgroundColor: [
          'grey',
          '#7124BD',
          
        ],
        borderColor: [
          'grey',
          '#7124BD',
          
        ],
        borderWidth: 1,
      },
    ],
  }



const data = {
    labels: ['1/2','2/2','3/2','4/2','5/2','6/2','7/2','8/2', '9/2', '10/2', '11/2', '12/2', 'today'],
    datasets: [
      {
        label: 'Number of Views',
        data: [100, 119, 140, 250, 200, 112,300,350,400,500,550,300,400],
        fill: false,
        backgroundColor: 'rgb(133, 36, 189)',
        borderColor: 'rgba(133, 36, 189, 0.2)',
      },
    ],
  }
  
  const options = {
      
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  }


const Overview = ()=>{


    return(
        <div className={styles.Overview}>
            <div className={styles.lineChartCon}>

                <div className={styles.viewHead}>
                  <div>Views</div>
                  <select>
                    <option>By Date</option>

                  </select>


                </div>
             
                <Line data={data} options={options} />
                </div>
                <div className={styles.lineChartCon}>
                <div className={styles.chartHeading}>Audiance Ratio</div>
                <Pie data={pidata} />
                </div>
                <div className={styles.lineChartCon}>
                <div className={styles.chartHeading}>Audiance Age</div>
                <Bar data={bardata} options={options}/>
                </div>
                <div className={styles.lineChartCon}>
                <div className={styles.chartHeading}>Audiance Contries</div>
                <WorldMap borderColor="var(--primary-text-color)" backgroundColor="var(--secondry-bg-color)" color="#7124BD" value-suffix="user" size="lg" data={mapData} /> 
                 </div>

        </div>
    )

}

export default Overview;